module.exports = __webpack_public_path__ + "static/media/breast.3c7e5bd0.svg";